import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesHttpService } from '../../services/categories.http';
import { PopupService } from '../../services/popup.service';
import { NotificationsService } from 'angular2-notifications';
import { mergeMap, tap } from 'rxjs';
import { OrganizationsService } from '../../services/organizations.service';

@Component({
  selector: 'app-organization-management',
  templateUrl: './organization-management.component.html',
  styleUrls: ['./organization-management.component.scss'],
})
export class OrganizationManagementComponent implements OnInit {
  @ViewChild('deletePopup', { static: true }) deletePopup: ElementRef;

  public categories: any[] = [];
  public organizations: any[] = [];
  public users: any[] = [];
  public organizationToEdit: any;

  constructor(
    private route: ActivatedRoute,
    private categoriesService: CategoriesHttpService,
    private organizationsService: OrganizationsService,
    private popupService: PopupService,
    private notifications: NotificationsService
  ) {}

  ngOnInit(): void {
    this.categories = (this.route.snapshot.data as any).categories;
    this.organizations = (this.route.snapshot.data as any).organizations.data;
    this.users = (this.route.snapshot.data as any).users.data;
  }

  updateOrganizationsList() {
    return this.organizationsService
      .getOrganizations()
      .pipe(tap((res: any) => (this.organizations = res.data)));
  }

  editOrganization(organization: any) {
    this.organizationToEdit = organization;
  }

  openDeleteConfirmPopup(organization: any) {
    this.popupService.showPopup(this.deletePopup, {
      payload: organization.organization_id,
    });
  }

  deleteOrganization(id: number) {
    this.organizationsService
      .deleteOrganization(id)
      .pipe(mergeMap(() => this.updateOrganizationsList()))
      .subscribe(() => {
        this.notifications.success('Success!', `Organization was deleted`);
      });
  }
}
